import {IPerRoadLayerImperial, IPerRoadLayerMetric} from "@/modules/perRoad/interfaces/perRoad";
import {IPrSimulatedLayerImperial, IPrSimulatedLayerMetric} from "@/modules/perRoad/interfaces/monteCarlo";
import {UnitSystem} from "@/interfaces/units";

export const convertDeterministicLayersImperial = (layers: IPerRoadLayerImperial[]): IPrSimulatedLayerImperial[] => {

  let depth = 0;

  return layers.map((layer, i): IPrSimulatedLayerImperial => {
    const thickness = layer.thickness_in.mean || 0;
    const simLayer: IPrSimulatedLayerImperial = {
      id: layer.id,
      name: layer.name,
      type: layer.type,
      unitSystem: UnitSystem.Imperial,
      layerNumber: i + 1,
      modulus_psi: layer.modulus_psi[0].mean || 0,
      poissonRatio: layer.poissonRatio,
      thickness_in: thickness,
      depthOfLayerTop_in: depth,
      depthOfLayerBottom_in: depth + thickness,
    };
    depth += thickness;

    return simLayer;
  });
};

export const convertDeterministicLayersMetric = (layers: IPerRoadLayerMetric[]): IPrSimulatedLayerMetric[] => {

  let depth = 0;

  return layers.map((layer, i): IPrSimulatedLayerMetric => {
    const thickness = layer.thickness_cm.mean || 0;
    const simLayer: IPrSimulatedLayerMetric = {
      id: layer.id,
      name: layer.name,
      type: layer.type,
      unitSystem: UnitSystem.Metric,
      layerNumber: i + 1,
      modulus_mpa: layer.modulus_mpa[0].mean || 0,
      poissonRatio: layer.poissonRatio,
      thickness_cm: thickness,
      depthOfLayerTop_cm: depth,
      depthOfLayerBottom_cm: depth + thickness,
    };
    depth += thickness;

    return simLayer;
  });
};
